import React from 'react';
import { Redirect } from 'react-router-dom';
import { KhilanetCouponsAppDataProvider } from '../../store/CouponsAppDataContext';
import { CouponsProvider } from '../../store/CouponsContext';
import { NotificationsProvider } from '../../store/NotificationsContext';
import Coupons from '../Home/Coupons/Coupons';
import { Path } from '../../core/Routes';
import { isAuthed } from './auth/khilanetAuth';

const KhilanetPage: React.FC = () => {
  if (!isAuthed()) {
    return <Redirect to={Path.KHILANET_LOGIN} />;
  }

  return (
    <KhilanetCouponsAppDataProvider>
      <CouponsProvider>
        <NotificationsProvider>
          <Coupons />
        </NotificationsProvider>
      </CouponsProvider>
    </KhilanetCouponsAppDataProvider>
  );
};

export default KhilanetPage;
